import * as React from "react";
import {Fragment} from "react";

import {Card, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import RedemptionRequest from "../../../domain/Transaction/inbound/RedemptionRequest";
import RedemptionLookupComponent from "./RedemptionLookupComponent";
import RedemptionResponseComponent from "./RedemptionResponseComponent";
import SFXLoadingComponent from "../../SFXLoadingComponent";
import SFXButtonComponent from "../../SFXButtonComponent";
import InboundTransactionRedemptionService
    from "../../../services/Transaction/inbound/InboundTransactionRedemptionService";
import InboundRequiredFieldsComponent from "./InboundRequiredFieldsComponent";
import RedemptionDeclarationComponent from "./RedemptionDeclarationComponent";
import SystemConfigService from "../../../services/SystemConfigService";
import ToastHelper from "../../../utils/ToastHelper";
import {withRouter} from "react-router-dom";
import DocumentInboundLimitUploadStep from "views/Unauthenticated/Registerv2/Steps/DocumentInboundLimitUploadStep";

const REDEMPTION_REQUEST = "redemption request";
const REDEMPTION_RESPONSE = "redemption response";
const BENEFICIARY_DETAILS = "beneficiary details";
const DECLARATION = "declaration";
const LIMIT_INCREASE = "limit increase";

class TransactionRedemptionComponent extends React.Component {

    constructor(props) {
        super(props);

        this.redemptionRef = null;
        this.requiredFieldsRef = null;

        this.state = {
            currentTab: REDEMPTION_REQUEST,

            lookupResponse: null,
            transactionRequest: null,
            transactionResponse: null,

            loading: false,
            requiredFieldsValid: false,
            inboundAvailable: false,
            limitIncreaseDocsValid: false,
            showNextButtonDeclarationScreen: false,
            documentUploadComplete: false,

            showTransactionCompleteModal: false,
            showErrorModal: false,
            showSuccessModal: false,
            quotationErrors: []
        };

        this.retrieveLookupResponse = this.retrieveLookupResponse.bind(this);
        this.requiredFieldsValid = this.requiredFieldsValid.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        SystemConfigService.retrieveConfigEntry('INBOUND_AVAILABLE').then(response => {
            if (response.id) {
                this.setState({
                    inboundAvailable: response.value
                });
            } else {
                ToastHelper.formatError(response);
            }
        });
    }

    retrieveLookupResponse = (lookupResponse) => {
        this.setState({
            lookupResponse: lookupResponse,
            currentTab: REDEMPTION_RESPONSE,
            documentUploadComplete: !lookupResponse.limitIncreaseRequired
        })
    };

    requiredFieldsValid = isValid => {
        this.setState({
            requiredFieldsValid: isValid
        })
    };

    generateTransactionRequest(reportingDeclarationVersion) {

        let requiredFields = this.state.lookupResponse.requiredFields.length !== 0 ? this.requiredFieldsRef.getValues() : [];

        if (this.state.lookupResponse.limitIncreaseRequired) {

            let documents = [];
            this.state.lookupResponse.requiredDocuments.forEach(singleRequiredDocument => {
                let documentPurpose = singleRequiredDocument.documentPurpose;
                let limitDocument = this.state.documents[documentPurpose];
                let documentType = limitDocument["document-type"];
                documents.push({
                    "document-purpose": documentPurpose,
                    "document-type-id": documentType.id,
                    "document-type": documentType.type,
                    "meta-data-id": limitDocument["inbound-limit-document-meta-data-id"]
                })
            })

            let request = RedemptionRequest.createWithDocuments(
                this.props.customer.registrationId,
                this.state.lookupResponse.transactionId,
                requiredFields,
                documents
            );

            this.setState({
                transactionRequest: request,
                loading: true
            }, () => this.createTransactionWithLimitIncrease(request,reportingDeclarationVersion))
        } else {
            let request = RedemptionRequest.create(
                this.props.customer.registrationId,
                this.state.lookupResponse.transactionId,
                requiredFields);

            this.setState({
                transactionRequest: request,
                loading: true
            }, () => this.createTransaction(request, reportingDeclarationVersion))
        }


    }

    createTransaction(transactionRequest, reportingDeclarationVersion) {
        InboundTransactionRedemptionService.requestRedemptionAndSignDeclaration(transactionRequest, reportingDeclarationVersion).then(response => {
            if (response.id) {
                this.setState({
                    transactionResponse: response,
                    loading: false,
                    showSuccessModal: true
                })
            } else {
                this.setState({
                    loading: false,
                    showErrorModal: true,
                    quotationErrors: response
                })
            }
        });
    }

    createTransactionWithLimitIncrease(transactionRequest, reportingDeclarationVersion) {
        InboundTransactionRedemptionService.requestRedemptionWithLimitIncreaseAndSignDeclaration(transactionRequest, reportingDeclarationVersion).then(response => {
            if (response.id) {
                this.setState({
                    transactionResponse: response,
                    loading: false,
                    showSuccessModal: true
                })
            } else {
                this.setState({
                    loading: false,
                    showErrorModal: true,
                    quotationErrors: response
                })
            }
        });
    }

    setValidLimitIncreaseDocs(isValid) {
        this.setState({
            limitIncreaseDocsValid: isValid
        })
    }

    documentUploadCompleted(showNextButton, documents) {
        let currentTab = LIMIT_INCREASE;
        if (showNextButton === true && this.state.documentUploadComplete) {
            currentTab = DECLARATION;
        }
        this.setState({
            showNextButtonDeclarationScreen: showNextButton,
            documents: documents,
            documentUploadComplete: true,
            currentTab: currentTab
        });
    }

    render() {

        if (this.state.loading) {
            return <SFXLoadingComponent/>
        }

        return <Fragment>
            {this.props.isMobile ? this.renderContent("mobile") : this.renderContent("browser")}
        </Fragment>
    }

    renderContent(className) {
        return <Fragment>
            {this.renderErrorModal(className)}
            {this.renderSuccessPage(className)}
            {this.state.currentTab === REDEMPTION_REQUEST && this.renderLookupRequest(className)}
            {this.state.currentTab === REDEMPTION_RESPONSE && (className === 'mobile' ? this.renderRedemptionResponse(className) : this.renderBrowserRedemptionResponse(className))}
            {this.state.currentTab === BENEFICIARY_DETAILS && (className === 'mobile' ? this.renderBeneficiaryDetails(className) : this.renderBrowserBeneficiaryDetails(className))}
            {this.state.currentTab === LIMIT_INCREASE && (className === 'mobile' ? this.renderLimitIncrease(className) : this.renderBrowserLimitIncrease(className))}
            {this.state.currentTab === DECLARATION && this.renderDeclaration(className)}
        </Fragment>
    }

    renderLookupRequest(className) {
        return <Fragment>
            {this.state.inboundAvailable === 'false'
                ?
                <div style={{textAlign: "center"}}>Service currently not available.</div>
                :
                <RedemptionLookupComponent
                    redemptionRef={ref => this.redemptionRef = ref}
                    className={className}
                    registrationId={this.props.customer.registrationId}
                    retrieveLookupResponse={this.retrieveLookupResponse}
                    setHeader={() => this.props.setHeader("Search for Transaction")}
                />
            }
        </Fragment>
    }

    renderRedemptionResponse(className) {
        return <Fragment>
            <RedemptionResponseComponent
                className={className}
                lookupResponse={this.state.lookupResponse}
                setHeader={() => this.props.setHeader("Transaction details")}
            />
            {this.state.lookupResponse.requiredFields.length !== 0 ? this.renderAcceptDetailsButton(className) : this.renderLimitIncreaseButtonWithoutFields(className)}
            {this.renderNewPinButton(className)}
        </Fragment>
    }

    renderBrowserRedemptionResponse(className) {
        return <Card style={{
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadius: "15px",
            width: "55%",
            margin: "auto",
            marginBottom: "100px"
        }}>
            {this.renderRedemptionResponse(className)}
        </Card>
    }

    renderBeneficiaryDetails(className) {
        return <Fragment>
            <InboundRequiredFieldsComponent
                registerRef={ref => {
                    this.requiredFieldsRef = ref
                }}
                hideSaveBeneficiary={true}
                className={className}
                requiredFields={this.state.lookupResponse.requiredFields}
                isValid={this.requiredFieldsValid}
                setHeader={() => this.props.setHeader("Beneficiary Details")}
            />
            {this.renderLimitIncreaseButton(className)}
        </Fragment>
    }

    renderBrowserBeneficiaryDetails(className) {
        return <Card style={{
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadius: "15px",
            width: "55%",
            margin: "auto",
            paddingBottom: "200px"
        }}>
            {this.renderBeneficiaryDetails(className)}
        </Card>
    }

    renderLimitIncrease(className) {
        return this.renderLimitIncreaseDetails(className);
    }

    renderBrowserLimitIncrease(className) {
        return <Card style={{
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadius: "15px",
            width: "55%",
            margin: "auto"
        }}>
            {this.renderLimitIncreaseDetails(className)}
        </Card>
    }

    renderLimitIncreaseDetails(className) {

        let style = {
            padding: "60px 15px 10px 15px",
            overflowY: "scroll"
        }
        if (className === "mobile") {
            style.maxHeight = "calc(100vh - 190px)";
        } else {
            style.maxHeight = "calc(100vh - 250px)";
        }

        return <Fragment>
            <div className={"step_shrink_buttons"} style={style}>
                <DocumentInboundLimitUploadStep
                    requiredDocuments={this.state.lookupResponse.requiredDocuments}
                    limitDocuments={this.state.documents}
                    onNextClick={(limitDocuments) => {
                        this.setState({
                            documentUploadComplete: true
                        }, () => this.documentUploadCompleted(true, limitDocuments));
                    }}
                    onBackClick={(limitDocuments) => {
                        this.setState({
                            currentTab: REDEMPTION_RESPONSE,
                            documents: limitDocuments
                        });
                    }}
                />
            </div>
        </Fragment>
    }

    renderDeclaration(className) {
        return <Fragment>
            <RedemptionDeclarationComponent
                className={className}
                idType={this.props.customer.idType}
                lookupResponse={this.state.lookupResponse}
                beneficiaryAmount={this.state.lookupResponse.beneficiaryAmount}
                submit={(reportingDeclarationVersion) => {
                    this.generateTransactionRequest(reportingDeclarationVersion)
                }}
                setHeader={() => this.props.setHeader("Declaration")}
                documentUploadComplete={this.state.documentUploadComplete}
                onModalCancelClick={() => {
                    this.setState({
                        currentTab: REDEMPTION_REQUEST
                    });
                }}
            />
        </Fragment>
    }

    renderSuccessPage(className) {

        return <Modal isOpen={this.state.showSuccessModal} style={{borderRadius: " 25px"}}>
            <ModalHeader className={className + "_modal_header"}>Successful</ModalHeader>
            <ModalBody>Your request has been submitted for approval.</ModalBody>
            <ModalFooter>
                <SFXButtonComponent
                    onClick={() => {
                        this.setState({
                            showSuccessModal: false,
                            currentTab: REDEMPTION_REQUEST
                        })
                        this.props.history.replace("/");
                    }}
                >Close</SFXButtonComponent>
            </ModalFooter>
        </Modal>
    }

    renderAcceptDetailsButton(className) {

        return <div className={className + "_register_button_div"}>
            <SFXButtonComponent
                className={className + "_orange_oval_button"}
                onClick={() => this.setState({currentTab: BENEFICIARY_DETAILS})}
            >Accept</SFXButtonComponent>
        </div>
    }

    renderNewPinButton(className) {
        return <div className={className + "_register_button_div"}>
            <SFXButtonComponent
                className={className + "_grey_oval_button"}
                onClick={() => this.setState({currentTab: REDEMPTION_REQUEST})}
            >Back</SFXButtonComponent>
        </div>
    }

    renderLimitIncreaseButton(className) {
        return <div className={className + "_register_button_div"}>
            <SFXButtonComponent
                id={"complete-btn"}
                className={className + "_orange_oval_button"}
                onClick={() =>
                    this.state.lookupResponse.limitIncreaseRequired === true ?
                        this.setState({currentTab: LIMIT_INCREASE})
                        :
                        this.setState({currentTab: DECLARATION})
                }
                disabled={!this.state.requiredFieldsValid}
            >Next</SFXButtonComponent>
        </div>
    }

    renderLimitIncreaseButtonWithoutFields(className) {
        return <div className={className + "_register_button_div"}>
            <SFXButtonComponent
                id={"complete-btn"}
                className={className + "_orange_oval_button"}
                onClick={() =>
                    this.state.lookupResponse.limitIncreaseRequired === true ?
                        this.setState({currentTab: LIMIT_INCREASE})
                        :
                        this.setState({currentTab: DECLARATION})
                }
            >Next</SFXButtonComponent>
        </div>
    }

    renderErrorModal(className) {
        return <Modal isOpen={this.state.showErrorModal} style={{borderRadius: " 25px"}}
                      className={'modal-danger modal-md'}>
            <ModalHeader className={className + "_modal_header modal-header"}>Error Occurred</ModalHeader>
            <ModalBody>{this.state.quotationErrors["message"]}</ModalBody>
            <ModalFooter>
                <SFXButtonComponent
                    onClick={() => this.setState({
                        showErrorModal: false,
                        currentTab: REDEMPTION_REQUEST
                    })}
                >Close</SFXButtonComponent>
            </ModalFooter>
        </Modal>
    }
}

export default withRouter(TransactionRedemptionComponent);
